import React from "react";
import Footer from "../Components/Footer";
import NavBar from "../Components/NavBar";
import Hero from "../Components/IfixPage/Hero";
import Section1 from "../Components/IfixPage/Section1";
import Section2 from "../Components/IfixPage/Section2";

function IfixPage() {
  return (
    <div>
      <NavBar />
      <Hero />
      <Section1 />
      <Section2 />
      <Footer />
    </div>
  );
}

export default IfixPage;
